import type { ScopeToggleOption } from '@/pages/analytics/components/ScopeToggle';

export type Grouping = 'by_report_type' | 'by_program' | 'by_submission_method';

/** The By Type / By Program / By Method toggle of the submitted-trend and time-to-submit charts. */
export const GROUPING_OPTIONS: ScopeToggleOption<Grouping>[] = [
  { value: 'by_report_type', label: 'By Type' },
  { value: 'by_program', label: 'By Program' },
  { value: 'by_submission_method', label: 'By Method' },
];
